import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

type KioskModalActionsProps = {
  isLoading: boolean;
  disabled?: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const KioskModalActions: React.FC<KioskModalActionsProps> = ({ onSubmit, onClose, isLoading, disabled }) => (
  <div className="flex flex-col gap-4">
    <Button onClick={onSubmit} loading={isLoading} disabled={disabled} className="w-full" testId="modal-next-btn">
      <FormattedMessage id="login.kiosk.modal.next" defaultMessage="Next" />
    </Button>
    <Button type={ButtonType.SECONDARY} onClick={onClose} className="w-full" testId="modal-cancel-btn">
      <FormattedMessage id="login.kiosk.modal.cancel" defaultMessage="Cancel" />
    </Button>
  </div>
);

export default KioskModalActions;
